var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2063 1.38062H9.20634C7.20634 1.38062 5.17134 2.88062 5.17134 6.19062C5.12952 6.95783 5.30075 7.72166 5.66608 8.39761C6.03141 9.07356 6.5766 9.63527 7.24134 10.0206L4.76634 14.4456C4.70961 14.5418 4.67969 14.6514 4.67969 14.7631C4.67969 14.8748 4.70961 14.9844 4.76634 15.0806C4.81766 15.1687 4.8904 15.2424 4.97781 15.2948C5.06522 15.3473 5.16447 15.3768 5.26634 15.3806H6.51134C6.63766 15.3868 6.76284 15.3541 6.87008 15.2871C6.97733 15.2201 7.06151 15.1219 7.11134 15.0056L9.40634 10.5056H9.57634V14.8156C9.57691 14.8926 9.59308 14.9688 9.62389 15.0393C9.65469 15.1099 9.69948 15.1736 9.75556 15.2264C9.81164 15.2792 9.87783 15.3201 9.95015 15.3466C10.0225 15.3731 10.0994 15.3847 10.1763 15.3806H11.2663C11.4132 15.3861 11.5564 15.3336 11.6649 15.2344C11.7734 15.1352 11.8386 14.9974 11.8463 14.8506V1.99062C11.8483 1.91247 11.8349 1.8347 11.8068 1.76175C11.7788 1.6888 11.7366 1.62209 11.6827 1.56544C11.6289 1.50879 11.5644 1.46331 11.4929 1.4316C11.4215 1.39988 11.3445 1.38256 11.2663 1.38062H11.2063ZM9.61634 8.52062H9.32134C8.17134 8.52062 7.49134 7.58562 7.49134 6.02062C7.49134 4.07062 8.35634 3.37562 9.16134 3.37562H9.63134L9.61634 8.52062Z",
    fill: "#D61E3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.00313da8e5311082def74610e6f52f59.svg";
export { ForwardRef as ReactComponent };